<div class="dropdown" [ngClass]="{'active': isToggle}" [class.classes]="classes">
  <span class="dropdown__toggle" (click)="toggleDropdown()">
    <ng-content select="[toggle]"></ng-content>
  </span>
  <div [ngClass]="{'show': isOpen, 'is-animate': isAnimate}" class="ui-menu-dropdown">
    <div class="ui-menu-dropdown__container">
      <ng-content select="[menu]"></ng-content>
    </div>
  </div>
</div>
